import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { MarketingCampaignStatus } from '@principle-theorem/principle-core/interfaces';
import { IconChipComponent } from '../icon-chip/icon-chip.component';
import {
  MarketingStatusColour,
  MarketingStatusIcon,
} from './marketing-status-display';

const statusColourMap: { [key in MarketingCampaignStatus]: string } = {
  [MarketingCampaignStatus.Draft]: MarketingStatusColour.Draft,
  [MarketingCampaignStatus.Active]: MarketingStatusColour.Success,
  [MarketingCampaignStatus.Paused]: MarketingStatusColour.Warning,
  [MarketingCampaignStatus.Completed]: MarketingStatusColour.Success,
};

const statusIconMap: { [key in MarketingCampaignStatus]: string } = {
  [MarketingCampaignStatus.Draft]: MarketingStatusIcon.Pending,
  [MarketingCampaignStatus.Active]: MarketingStatusIcon.Running,
  [MarketingCampaignStatus.Paused]: MarketingStatusIcon.Paused,
  [MarketingCampaignStatus.Completed]: MarketingStatusIcon.Complete,
};

@Component({
  selector: 'pr-campaign-status',
  templateUrl: './campaign-status.component.html',
  styleUrl: './campaign-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, IconChipComponent],
  host: {
    class: 'flex',
  },
})
export class CampaignStatusComponent {
  @Input() status?: MarketingCampaignStatus;

  statusColor(status?: MarketingCampaignStatus): string {
    return status ? statusColourMap[status] : MarketingStatusColour.Draft;
  }

  statusIcon(status?: MarketingCampaignStatus): string {
    return status ? statusIconMap[status] : MarketingStatusIcon.Unknown;
  }
}
